import { useFormContext } from "react-hook-form";
import { FieldConfig } from "../../formConfig";

export default function CheckboxField({ field, vertical }: { field: FieldConfig; vertical?: boolean }) {
  const { register } = useFormContext();
  return (
    <div className={vertical ? "choices choices-vertical" : "choices"}>
      {(field.options ?? []).map((opt) => (
        <label key={opt}>
          <input type="checkbox" value={opt} {...register(field.id)} /> {opt}
        </label>
      ))}
    </div>
  );
}
